import apiService, { API_ENDPOINTS } from "../utils/apiInterceptor";

// Voice Service - handles all voice call-related API calls
export const voiceService = {
  // Send voice call
  sendVoiceCall: async (voiceData) => {
    try {
      return await apiService.post("/api/voice/send-voice", voiceData);
    } catch (error) {
      throw error;
    }
  },

  // Get voice call history
  getVoiceCallHistory: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams(params).toString();
      const endpoint = queryParams
        ? `/api/voice/history?${queryParams}`
        : "/api/voice/history";

      return await apiService.get(endpoint);
    } catch (error) {
      throw error;
    }
  },
  // Get available templates based on template type and language
  getTemplates: async (templateType, language) => {
    try {
      const params = new URLSearchParams({
        templateType,
        language,
      });
      return await apiService.get(`/api/templates?${params}`);
    } catch (error) {
      throw error;
    }
  },

  // Get available languages
  getLanguages: async () => {
    try {
      return await apiService.get("/api/voice/languages");
    } catch (error) {
      throw error;
    }
  },
};

export default voiceService;
